import { render, staticRenderFns } from "./_name.vue?vue&type=template&id=2f8023a4&"
import script from "./_name.vue?vue&type=script&lang=js&"
export * from "./_name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports